import React from "react";
import { BoxHijo } from "./CategoriaHijosStyled";
var CategoriaHijos = function (_a) {
    var categoria = _a.categoria;
    var cambioVisiblidadHijos = function () {
        console.log("cambioVisiblidadHijos");
    };
    return (React.createElement(BoxHijo, null,
        React.createElement("ul", null, categoria.hijos.map(function (hijo) { return (React.createElement("li", { key: hijo.id },
            React.createElement("a", { href: hijo.urlseo }, hijo.nombre))); }))));
};
export default CategoriaHijos;
